export function updateTableHeight(vueInstance) {
  vueInstance.$nextTick(() => {
    const fn = () => {
      if(vueInstance.$el && vueInstance.$el.querySelector){
        const tableElement = vueInstance.$el.querySelector('.table-body');
        if (tableElement) {
          const top = $(tableElement).offset().top;
          const height = `calc(100vh - ${top}px)`;
          // console.log(`height updated to ${height}`);
          $(tableElement).css('height', height);
        }
      }
    };
    setTimeout(fn, 200);
    setTimeout(fn, 1000);
  });
}
